import React from 'react';
import './Button.css';

/**
 * Button v2 — Professional SaaS button
 * Props: variant (primary|ghost|danger|success|subtle|flat), size (xs|sm|md|lg|xl),
 *        loading, disabled, icon (Lucide component), iconRight, block, className
 */
const Button = ({
  children,
  variant  = 'primary',
  size     = 'md',
  loading  = false,
  disabled = false,
  icon: Icon,
  iconRight: IconRight,
  block    = false,
  type     = 'button',
  onClick,
  className = '',
  ...props
}) => (
  <button
    type={type}
    className={[
      'btn',
      `btn-${variant}`,
      `btn-${size}`,
      loading ? 'btn-loading' : '',
      block   ? 'btn-block'   : '',
      className,
    ].filter(Boolean).join(' ')}
    disabled={disabled || loading}
    onClick={onClick}
    {...props}
  >
    {loading && <span className="btn-spinner" />}
    <span className={loading ? 'btn-content-hidden' : ''} style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
      {Icon && !loading && <Icon />}
      {children}
      {IconRight && !loading && <IconRight />}
    </span>
  </button>
);

export default Button;
